import {
  HubManifestTemporaryItem,
  InHubScanGenerate,
  InHubScanGenerateList,
  HubInOutManifest,
  HubManifestDetail,
  HubManifestDetailItem,
  ResponsePayload,
  HubInOutManifestEntities,
  HubManifestTemporaryList
} from "@/domain/entities/HubToHub";
import { Pagination } from "@/domain/entities/Pagination";
import { AxiosResponse } from "axios";

export class HubToHubMapper {
  public convertGenerateInHubScanFromApi(
    res: AxiosResponse
  ): InHubScanGenerateList {
    const { data } = res;

    const ScanData: InHubScanGenerate[] = [];
    if (data.data.length === 0) {
      return new InHubScanGenerateList({
        data: [],
        success: false,
        message: "No data found"
      });
    } else {
      data.data.map((item: any) => {
        ScanData.push(
          new InHubScanGenerate({
            hmtId: item.hmt_id,
            hmtSttNo: item.hmt_stt_no,
            hmtBagNo: item.hmt_bag_no,
            hmtRefNo: item.hmt_ref_no,
            hmtDemNo: item.hmt_dem_no,
            hmtProductType: item.hmt_product_type,
            hmtPiece: item.hmt_pieces,
            hmtGrossWeight: item.hmt_gross_weight,
            hmtScanStatus: item.hmt_scan_status,
            hmtDemOrBagStatus: item.hmt_dem_or_bag_status
          })
        );
      });
    }

    return new InHubScanGenerateList({
      data: ScanData,
      success: data.success,
      message: data.message
    });
  }

  public convertGetListHubManifestTemporaryFromApi(
    res: AxiosResponse
  ): HubManifestTemporaryList {
    const { data } = res;

    const ScanData: HubManifestTemporaryItem[] = [];
    if (data.data.length === 0) {
      return new HubManifestTemporaryList({
        data: [],
        pagination: new Pagination(1, 20, 0)
      });
    } else {
      data.data.map((item: any) => {
        ScanData.push(
          new HubManifestTemporaryItem({
            hmtId: item.hmt_id,
            hmtSttNo: item.hmt_stt_no,
            hmtBagNo: item.hmt_bag_no,
            hmtRefNo: item.hmt_ref_no,
            hmtPieces: item.hmt_pieces,
            hmtGrossWeight: item.hmt_gross_weight,
            hmtProductType: item.hmt_product_type,
            hmtDemNo: item.hmt_dem_no,
          })
        );
      });
    }
    const pagination = new Pagination(
      data.meta.page,
      data.meta.limit,
      data.meta.total_records
    );

    return new HubManifestTemporaryList({
      data: ScanData,
      pagination: pagination
    });
  }

  public convertGetHubInOutManifestListFromApi(
    res: AxiosResponse
  ): HubInOutManifestEntities {
    const { data } = res;

    const ScanData: HubInOutManifest[] = [];
    data.data.map((item: any) => {
      ScanData.push(
        new HubInOutManifest({
          hmId: item.hm_id,
          hmNo: item.hm_no,
          hmStts: item.hm_stts,
          hmSttPieces: item.hm_stt_pieces,
          hmSttGrossWeights: item.hm_stt_gross_weights,
          hmCreatedAt: item.hm_created_at,
          hmCreatedByName: item.hm_created_by_name,
          hmCreatedByRole: item.hm_created_by_role,
          hmPlateNumber: item.hm_plate_number,
          hmHubDestinationName: item.hm_hub_destination_name,
        })
      );
    });

    const pagination = new Pagination(
      data.meta.page,
      data.meta.limit,
      data.meta.total_records
    );

    return new HubInOutManifestEntities(pagination, ScanData);
  }

  public convertPayloadProsesManifest(res: AxiosResponse<any>): ResponsePayload {
    const { data } = res;
    return new ResponsePayload({
      success: data.success,
      code: data.code,
      message: data.message,
      data: data.data,
      });
  }

  public convertHubManifestDetail(res: AxiosResponse<any>) {
    const {
      data: { data }
    } = res;
    return new HubManifestDetail({
      hmId: data.hm_id,
      hmNo: data.hm_no,
      hmStts: data.hm_stts,
      hmSttPieces: data.hm_stt_pieces,
      hmSttGrossWeights: data.hm_stt_gross_weights,
      hmCreatedAt: data.hm_created_at,
      hmCreatedByName: data.hm_created_by_name,
      hmCreatedByRole: data.hm_created_by_role,
      hmPlateNumber: data.hm_plate_number,
      hmHubDestinationName: data.hm_hub_destination_name,
      hmHubName: data.hm_hub_name,
      stts: (data.stts || []).map(
        (stt: any) =>
          new HubManifestDetailItem({
            hmdId: stt.hmd_id,
            hmdDemNo: stt.hmd_dem_no,
            hmdBagNo: stt.hmd_bag_no,
            hmdSttNo: stt.hmd_stt_no,
            hmdRefNo: stt.hmd_ref_no,
            hmdPieces: stt.hmd_pieces,
            hmdGrossWeight: stt.hmd_gross_weight,
            hmdProductType: stt.hmd_product_type,
            hmdDestinationDistrictName: stt.hmd_destination_district_name,
          })
      )
    });
  }

}
